import apiClient from '@/services/axios'

export async function patch(bookingId, bookingCustomer) {

    const customer = {
        name: bookingCustomer.name,
        phoneNumber: bookingCustomer.phoneNumber,
        email: bookingCustomer.email,
        password: "",
        companyName: "",
        vatNo: ""
    }
  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/' + bookingId + '/customer', customer);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to patch booking customer.')
}
